// React
import React, { useEffect } from 'react';
import { Card, Spinner } from 'reactstrap';
import { useHistory, useLocation } from 'react-router-dom';

// Containers Injection
import {
  PageWrapper,
  DropdownDatatable,
} from '../../containers/componentsInjection';
import { ValidationOfProposalsInjetion } from '../../containers/validationOfProposalsInjection';

// Common
import { columns } from '../../common/columns';

export const ValidationOfProposals = () => {
  const history = useHistory();
  const location = useLocation();

  const { getPreProposals, preProposals, loading } =
    ValidationOfProposalsInjetion();

  useEffect(() => {
    getPreProposals();
  }, []);

  return (
    <PageWrapper title={'Pré-Propostas'}>
      <div className="flex-grow-1 mb-3">
        {/* <h4 className="fs-16 mb-1">Pré-Propostas</h4> */}
        <p className="text-muted mb-0">
          Você tem um total de {location.state || '0'} propostas aguardando
          aprovar
        </p>
      </div>
      <Card>
        <DropdownDatatable
          loading={loading}
          progressPending={loading}
          progressComponent={
            <Spinner
              type="grow"
              color="primary"
              style={{
                margin: 25,
              }}
            />
          }
          columns={columns}
          data={preProposals || []}
          pagination
          persistTableHead
          actions={[
            {
              id: 1,
              name: 'edit',
              label: 'Editar',
              onPress: (cellProps) =>
                history.push(`/pre-proposta/edit/${cellProps.id}`),
              icon: 'la-pen',
              classNameColorIcon: 'primary',
            },
          ]}
          noDataComponent="Nenhum registro encontrado!"
          keysSearch={['name']}
        />
      </Card>
    </PageWrapper>
  );
};
